
import React from 'react';
import { ContractGroup } from "@/lib/types";
import { ChevronDown, ChevronRight } from "lucide-react";

interface GroupHeaderRowProps {
  group: ContractGroup;
  columns?: number;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
  contractCount?: number;
  totalCostConverted?: number;
  totalIncomeConverted?: number;
  defaultCurrencySymbol?: string;
  isConvertingTotal?: boolean;
  isCurrencyConversionEnabled?: boolean;
}

export function GroupHeaderRow({ 
  group, 
  columns = 10, 
  isExpanded, 
  onToggleExpand,
  contractCount,
  totalCostConverted,
  totalIncomeConverted,
  defaultCurrencySymbol,
  isConvertingTotal,
  isCurrencyConversionEnabled
}: GroupHeaderRowProps) {
  return (
    <tr 
      className={`group cursor-pointer hover:bg-muted/80 ${isExpanded ? 'bg-muted/60' : 'bg-muted/30'}`}
      onClick={onToggleExpand}
    >
      <th colSpan={columns} className="text-left px-4 py-2 font-semibold flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {onToggleExpand && (
            <span className="text-muted-foreground">
              {isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </span>
          )}
          <span>{group.name}</span>
          {contractCount !== undefined && (
            <span className="text-sm text-muted-foreground ml-2">
              ({contractCount} contract{contractCount !== 1 ? 's' : ''})
            </span>
          )}
        </div>
        
        {isCurrencyConversionEnabled && totalCostConverted !== undefined && (
          <div className="flex items-center space-x-4 text-sm">
            <div>
              <span className="text-muted-foreground mr-1">Cost:</span>
              <span className="font-medium">
                {isConvertingTotal ? '...' : `${defaultCurrencySymbol}${totalCostConverted.toLocaleString()}`}
              </span>
            </div>
            {totalIncomeConverted !== undefined && (
              <div>
                <span className="text-muted-foreground mr-1">Income:</span>
                <span className="font-medium">
                  {isConvertingTotal ? '...' : `${defaultCurrencySymbol}${totalIncomeConverted.toLocaleString()}`}
                </span>
              </div>
            )}
          </div>
        )}
      </th>
    </tr>
  );
}
